import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { GET, POST, PUT, DELETE, newFetch } from '../../../../../helpers/fetch';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../../components/SweetAlert';

const Incidents = ({ history }) => {
  const [SEVs, setSEVs] = useState([]);
  const [incidents, setIncidents] = useState([]);
  const [oldIncidents, setOldIncidents] = useState([]);
  const [newIncidents, setNewIncidents] = useState([]);

  useEffect(() => {
    const fetchSEVs = async () => {
      let api_path = '/tt/severity';
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setSEVs(response.data);
      }
    };

    const fetchIncidents = async () => {
      let api_path = '/tt/incident';
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setIncidents(response.data);
        setOldIncidents(JSON.parse(JSON.stringify(response.data)));
      }
    };

    fetchSEVs();
    fetchIncidents();
  }, []);

  const addNewIncident = () => {
    var newID = '';

    if (newIncidents.length > 0) {
      const lastNewIncident = [...newIncidents].pop();
      newID = lastNewIncident.id + 1;
    } else {
      const lastOldIncident = [...oldIncidents].pop();
      newID = lastOldIncident ? lastOldIncident.id + 1 : 1;
    }

    setNewIncidents([
      ...newIncidents,
      {
        id: newID,
        name: '',
        sev_id: '',
        // is_enabled: true
      },
    ]);
  };

  const updateNewIncidentName = (index, e) => {
    let clone = [...newIncidents];
    clone[index].name = e.target.value;
    setNewIncidents(clone);
  };

  const updateNewIncidentLevel = (index, e) => {
    let clone = [...newIncidents];
    clone[index].sev_id = e.target.value;
    setNewIncidents(clone);
  };

  const deleteNewIncident = (index) => {
    setNewIncidents([...newIncidents].filter((incident, i) => i !== index));
  };

  const enableDisableNewIncident = (index) => {
    let clone = [...newIncidents];
    clone[index].is_enabled = !clone[index].is_enabled;
    setNewIncidents(clone);
  };

  const updateOldIncidentName = (index, e) => {
    let clone = [...oldIncidents];
    clone[index].name = e.target.value;
    setOldIncidents(clone);
  };

  const updateOldIncidentLevel = (index, e) => {
    let clone = [...oldIncidents];
    clone[index].sev_id = e.target.value;
    setOldIncidents(clone);
  };

  // const deleteOldincident = async id => {
  //     if (await AlertService.confirm("", 'Are you sure you want to delete this incident?')) {
  //         let api_path = `/tt/incident/${id}`
  //         let response = await newFetch(DELETE, api_path)

  //         ToastUtil.success(response.message)
  //         response.success && window.location.reload()
  //     }
  // }

  const enableDisableOldIncident = (index) => {};

  const discardIncidentHandler = () => {
    setOldIncidents(incidents);
    setNewIncidents([]);
  };

  const submitIncidentHandler = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to update Incidents?'
      )
    ) {
      let api_path = `/tt/incident`;

      // // update old incident
      if (oldIncidents.length > 0) {
        let update_data = {
          incidents: oldIncidents.map((incident) => ({
            id: incident.id,
            name: incident.name,
            sev_id: incident.sev_id,
          })),
        };
        let update_response = await newFetch(PUT, api_path, update_data);

        ToastUtil.success(update_response.message);

        update_response.success &&
          newIncidents.length <= 0 &&
          window.location.reload();
      }

      // // create new incident
      if (newIncidents.length > 0) {
        let create_data = {
          incidents: newIncidents.map((incident) => ({
            name: incident.name,
            sev_id: incident.sev_id,
          })),
        };
        let create_response = await newFetch(POST, api_path, create_data);

        ToastUtil.success(create_response.message);
        create_response.success && window.location.reload();
      }
    }
  };

  return (
    <form
      onSubmit={(e) => submitIncidentHandler(e)}
      className="d-flex flex-column"
    >
      <div className="p-4 d-flex flex-column">
        <h5 className="mb-4 pb-2">Incidents</h5>
        <div className="row border-bottom mb-2 pb-2 mx-1">
          <div className="col-1 p-0 fw-bold">ID</div>
          <div className="col-7 p-0 fw-bold">Incident</div>
          <div className="col-3 p-0 text-center fw-bold">SEV Level</div>
          {/* <div className="col-1 p-0 text-center fw-bold">Enabled</div> */}
          <div className="col-1"></div>
        </div>
        {oldIncidents.map((incident, index) => (
          <div key={index} className="row py-2">
            <div className="col-1">{incident.id}</div>
            <div className="col-7">
              <input
                type="text"
                className="form-control adjust-fs"
                value={incident.name}
                onChange={(e) => updateOldIncidentName(index, e)}
              />
            </div>
            <div className="col-3">
              {SEVs && SEVs.length > 0 && (
                <input
                  type="number"
                  min="0"
                  max={[...SEVs].pop().id}
                  className="form-control text-center adjust-fs"
                  value={incident.sev_id}
                  onChange={(e) => updateOldIncidentLevel(index, e)}
                />
              )}
            </div>
            {/* <div className="col-1 text-center" style={{ cursor: 'pointer' }} onClick={() => enableDisableOldIncident(index)}><i className="fas fa-times text-danger pt-2"></i></div> */}
            {/* <div className="col-1 text-center" style={{ cursor: 'pointer' }} onClick={() => deleteOldincident(incident.id)}><i className="fas fa-times text-danger pt-2"></i></div> */}
            <div className="col-1 text-center"></div>
          </div>
        ))}
        {newIncidents.map((incident, index) => (
          <div key={index} className="row py-2">
            <div className="col-1 text-center">{incident.id}</div>
            <div className="col-7">
              <input
                type="text"
                className="form-control adjust-fs"
                value={incident.name}
                onChange={(e) => updateNewIncidentName(index, e)}
              />
            </div>
            <div className="col-3">
              {SEVs && SEVs.length > 0 && (
                <input
                  type="number"
                  min="0"
                  max={[...SEVs].pop().id}
                  className="form-control text-center adjust-fs"
                  value={incident.sev_id}
                  onChange={(e) => updateNewIncidentLevel(index, e)}
                />
              )}
            </div>
            {/* <div className="col-1 text-center" style={{ cursor: 'pointer' }} onClick={() => enableDisableNewIncident(index)}>{incident.is_enabled ? <i className="fas fa-check text-success pt-2"></i> : <i className="fas fa-times text-danger pt-2"></i>}</div> */}
            <div
              className="col-1 text-center"
              style={{ cursor: 'pointer' }}
              onClick={() => deleteNewIncident(index)}
            >
              <i className="fas fa-trash pt-2"></i>
            </div>
          </div>
        ))}

        <button
          type="button"
          className="btn btn-block btn-outline-brand text-start mt-2 p-3 adjust-fs adjust-shadow"
          onClick={() => addNewIncident()}
        >
          <i className="fas fa-plus me-2" /> Add New Incident
        </button>
      </div>
      <div
        style={{
          height: '4.5rem',
        }}
        className="border-top bg-white d-flex align-items-center justify-content-end mt-auto p-4"
      >
        <button
          type="button"
          onClick={discardIncidentHandler}
          className="btn btn-outline-brand adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Discard
        </button>
        <button
          type="submit"
          className="btn btn-brand ms-3 adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Save changes
        </button>
      </div>
    </form>
  );
};

export default withRouter(Incidents);
